export default {
  data() { return { assetStatus: this.$route.query.status === 'deleted' ? 'deleted' : 'all' }; },
  computed: {
    projectId() { return this.$STORE.state.userConfig.setProjectId; },
    statusQuery() {
      if (this.assetStatus === 'pending') return '&registration_status=pending';
      if (this.assetStatus === 'deleted') return '&include_deleted=true&is_deleted=true';
      return this.assetStatus === 'all' ? '' : '&is_active=' + (this.assetStatus === 'active');
    },
  },
  watch: {
    projectId() {
      this.dataPackage = []; this.totalDataCount = 0;
      if (this.getParent) { this.parentRecord = {}; this.getParent(); }
      if (this.getBuilding) { this.buildingRecord = {}; this.getBuilding(); }
      this.applyFilters();
    },
    '$route.query.status'(value) { this.assetStatus = value === 'deleted' ? 'deleted' : 'all'; this.applyFilters(); },
  },
  beforeDestroy() { this.requestVersion++; },
  methods: { assetState(record) { return record.is_deleted ? 'حذف‌شده' : (record.registration_status === 'pending' ? 'ثبت موقت · ' : '') + (record.is_active ? 'فعال' : 'غیرفعال'); } },
};
